import type { SVGProps } from 'react';
const SvgSpeakerPhone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#speaker_phone_svg__a)">
      <path
        fill="currentColor"
        d="M7 7.07 8.43 8.5A5.05 5.05 0 0 1 12 7.02c1.39 0 2.66.57 3.57 1.48L17 7.07A7.052 7.052 0 0 0 12 5c-1.95 0-3.72.79-5 2.07ZM12 1C8.98 1 6.24 2.23 4.25 4.21l1.41 1.41A8.95 8.95 0 0 1 12 3c2.47 0 4.72 1 6.34 2.62l1.41-1.41A10.963 10.963 0 0 0 12 1Zm2.86 9.01L9.14 10C8.51 10 8 10.51 8 11.14v9.71c0 .63.51 1.14 1.14 1.14h5.71c.63 0 1.14-.51 1.14-1.14v-9.71c.01-.63-.5-1.13-1.13-1.13ZM15 20H9v-8h6v8Z"
      />
    </g>
    <defs>
      <clipPath id="speaker_phone_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSpeakerPhone;
